"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[265],{

/***/ 265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M4": function() { return /* binding */ BarChartLoader; },
  "PK": function() { return /* binding */ CandleChartLoader; },
  "fn": function() { return /* binding */ LineChartLoader; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44147);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(62077);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 1 modules
var src = __webpack_require__(68486);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Svg.tsx
var Svg = __webpack_require__(44976);
;// CONCATENATED MODULE: ./src/views/Info/components/ChartLoaders/LineChartLoaderSVG.tsx




var LineChartLoaderSVG = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "100%",
        height: "100%",
        preserveAspectRatio: "none",
        viewBox: "0 0 100 50"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M 0 49 C 1 49 1 45 4 47 C 7 49 7 35 11 37 C 13 38 14 32 16 34 C 18 35.6667 20 40 22 39 C 24 38 24 34 26 34 C 27 34 29 39 32 36 C 33 35 34 32 35 32 C 37 32 37 35 39 34 C 40 33 39 29 43 31 C 46 32 45 28 47 30 C 50 32 49 22 51 24 Q 53 26 55 24 C 56 23 56 25 57 26 C 58 27 59 28 60 28 C 63 28 66 17 67 16 C 68 15 69 17 70 16 C 71 15 71 13 74 13 C 76 13 76 14 77 15 C 79 17 80 18 82 18 C 83 18 83 17 84 17 C 87 17 89 24 91 24 C 93 24 95 20 96 17 C 97.6667 13.3333 98 9 101 6",
                stroke: "#7645D9",
                strokeWidth: "0.2",
                strokeDasharray: "156",
                strokeDashoffset: "156",
                fill: "transparent",
                opacity: "0.5",
                filter: "url(#glow)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                    id: "firstline",
                    attributeName: "stroke-dashoffset",
                    dur: "2s",
                    from: "156",
                    to: "-156",
                    begin: "0s;firstline.end+0.5s"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M 0 49 C 1 49 1 45 4 47 C 7 49 7 35 11 37 C 13 38 14 32 16 34 C 18 35.6667 20 40 22 39 C 24 38 24 34 26 34 C 27 34 29 39 32 36 C 33 35 34 32 35 32 C 37 32 37 35 39 34 C 40 33 39 29 43 31 C 46 32 45 28 47 30 C 50 32 49 22 51 24 Q 53 26 55 24 C 56 23 56 25 57 26 C 58 27 59 28 60 28 C 63 28 66 17 67 16 C 68 15 69 17 70 16 C 71 15 71 13 74 13 C 76 13 76 14 77 15 C 79 17 80 18 82 18 C 83 18 83 17 84 17 C 87 17 89 24 91 24 C 93 24 95 20 96 17 C 97.6667 13.3333 98 9 101 6",
                stroke: "#7645D9",
                strokeWidth: "0.2",
                strokeDasharray: "156",
                strokeDashoffset: "156",
                fill: "transparent",
                opacity: "0.5",
                filter: "url(#glow)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                    id: "secondline",
                    attributeName: "stroke-dashoffset",
                    dur: "2s",
                    from: "156",
                    to: "-156",
                    begin: "1.3s;secondline.end+0.5s"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    id: "glow",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                            className: "blur",
                            result: "coloredBlur",
                            stdDeviation: "4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("feMerge", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feMergeNode", {
                                    in: "coloredBlur"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feMergeNode", {
                                    in: "coloredBlur"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feMergeNode", {
                                    in: "coloredBlur"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feMergeNode", {
                                    in: "SourceGraphic"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var ChartLoaders_LineChartLoaderSVG = (LineChartLoaderSVG);

;// CONCATENATED MODULE: ./src/views/Info/components/ChartLoaders/BarChartLoaderSVG.tsx




var BarChartLoaderSVG = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "100%",
        height: "100%",
        viewBox: "0 0 50 25",
        preserveAspectRatio: "none",
        opacity: "0.1"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("rect", {
                width: "8%",
                fill: "#1FC7D4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "height",
                        dur: "0.9s",
                        values: "15%; 90%; 15%",
                        keyTimes: "0; 0.55; 1",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "y",
                        dur: "0.9s",
                        values: "85%; 10%; 85%",
                        keyTimes: "0; 0.55; 1",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("rect", {
                x: "10.222%",
                width: "8%",
                fill: "#1FC7D4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "height",
                        dur: "0.9s",
                        values: "15%; 90%; 15%",
                        keyTimes: "0; 0.55; 1",
                        repeatCount: "indefinite",
                        begin: "-0.8s"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "y",
                        dur: "0.9s",
                        values: "85%; 10%; 85%",
                        keyTimes: "0; 0.55; 1",
                        repeatCount: "indefinite",
                        begin: "-0.8s"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("rect", {
                x: "20.444%",
                width: "8%",
                fill: "#1FC7D4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "height",
                        dur: "0.9s",
                        values: "15%; 90%; 15%",
                        keyTimes: "0; 0.55; 1",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "y",
                        dur: "0.9s",
                        values: "85%; 10%; 85%",
                        keyTimes: "0; 0.55; 1",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("rect", {
                x: "30.666%",
                width: "8%",
                fill: "#1FC7D4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "height",
                        dur: "0.9s",
                        values: "15%; 90%; 15%",
                        keyTimes: "0; 0.55; 1",
                        repeatCount: "indefinite",
                        begin: "-0.6s"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "y",
                        dur: "0.9s",
                        values: "85%; 10%; 85%",
                        keyTimes: "0; 0.55; 1",
                        repeatCount: "indefinite",
                        begin: "-0.6s"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("rect", {
                x: "40.888%",
                width: "8%",
                fill: "#1FC7D4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "height",
                        dur: "0.9s",
                        values: "15%; 90%; 15%",
                        keyTimes: "0; 0.55; 1",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "y",
                        dur: "0.9s",
                        values: "85%; 10%; 85%",
                        keyTimes: "0; 0.55; 1",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("rect", {
                x: "51.11%",
                width: "8%",
                fill: "#1FC7D4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "height",
                        dur: "0.9s",
                        values: "15%; 90%; 15%",
                        keyTimes: "0; 0.55; 1",
                        repeatCount: "indefinite",
                        begin: "-0.4s"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "y",
                        dur: "0.9s",
                        values: "85%; 10%; 85%",
                        keyTimes: "0; 0.55; 1",
                        repeatCount: "indefinite",
                        begin: "-0.4s"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("rect", {
                x: "61.332%",
                width: "8%",
                fill: "#1FC7D4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "height",
                        dur: "0.9s",
                        values: "15%; 90%; 15%",
                        keyTimes: "0; 0.55; 1",
                        repeatCount: "indefinite",
                        begin: "-0.3s"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "y",
                        dur: "0.9s",
                        values: "85%; 10%; 85%",
                        keyTimes: "0; 0.55; 1",
                        repeatCount: "indefinite",
                        begin: "-0.3s"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("rect", {
                x: "71.554%",
                width: "8%",
                fill: "#1FC7D4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "height",
                        dur: "0.9s",
                        values: "15%; 90%; 15%",
                        keyTimes: "0; 0.55; 1",
                        repeatCount: "indefinite",
                        begin: "-0.2s"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "y",
                        dur: "0.9s",
                        values: "85%; 10%; 85%",
                        keyTimes: "0; 0.55; 1",
                        repeatCount: "indefinite",
                        begin: "-0.2s"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("rect", {
                x: "81.776%",
                width: "8%",
                fill: "#1FC7D4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "height",
                        dur: "0.9s",
                        values: "15%; 90%; 15%",
                        keyTimes: "0; 0.55; 1",
                        repeatCount: "indefinite",
                        begin: "-0.1s"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "y",
                        dur: "0.9s",
                        values: "85%; 10%; 85%",
                        keyTimes: "0; 0.55; 1",
                        repeatCount: "indefinite",
                        begin: "-0.1s"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("rect", {
                x: "91.998%",
                width: "8%",
                fill: "#1FC7D4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "height",
                        dur: "0.9s",
                        values: "15%; 90%; 15%",
                        keyTimes: "0; 0.55; 1",
                        repeatCount: "indefinite"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "y",
                        dur: "0.9s",
                        values: "85%; 10%; 85%",
                        keyTimes: "0; 0.55; 1",
                        repeatCount: "indefinite"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var ChartLoaders_BarChartLoaderSVG = (BarChartLoaderSVG);

;// CONCATENATED MODULE: ./src/views/Info/components/ChartLoaders/CandleChartLoaderSVG.tsx




var CandleChartLoaderSVG = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "100%",
        height: "100%",
        viewBox: "0 0 100 50",
        opacity: "0.1"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("rect", {
                width: "5%",
                fill: "#31D0AA",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "height",
                        dur: "2s",
                        values: "0%; 40%; 40%; 10%; 10%",
                        keyTimes: "0; 0.125; 0.5; 0.625; 1",
                        repeatCount: "indefinite"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "y",
                        dur: "2s",
                        from: "50%",
                        to: "30%",
                        values: "30%; 10%; 10%; 25%; 25%",
                        keyTimes: "0; 0.125; 0.5; 0.625; 1",
                        repeatCount: "indefinite"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "rx",
                        dur: "2s",
                        values: "0%; 0%; 100%; 100%;",
                        keyTimes: "0; 0.6; 0.625; 1",
                        repeatCount: "indefinite"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "x",
                        dur: "2s",
                        values: "32.5%; 32.5%; 47.5%; 47.5%;",
                        keyTimes: "0; 0.7; 0.8; 1",
                        repeatCount: "indefinite"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "opacity",
                        dur: "2s",
                        values: "1; 1; 0; 0;",
                        keyTimes: "0; 0.75; 0.9; 1",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("rect", {
                width: "5%",
                fill: "#31D0AA",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "height",
                        dur: "2s",
                        values: "0%; 0%; 20%; 20%; 10%; 10%",
                        keyTimes: "0; 0.125; 0.25; 0.5; 0.625; 1",
                        repeatCount: "indefinite"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "y",
                        dur: "2s",
                        values: "15%; 15%; 5%; 5%; 25%; 25%",
                        keyTimes: "0; 0.125; 0.25; 0.5; 0.625; 1",
                        repeatCount: "indefinite"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "rx",
                        dur: "2s",
                        values: "0%; 0%; 100%; 100%;",
                        keyTimes: "0; 0.6; 0.625; 1",
                        repeatCount: "indefinite"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "x",
                        dur: "2s",
                        values: "42.5%; 42.5%; 47.5%; 47.5%;",
                        keyTimes: "0; 0.7; 0.8; 1",
                        repeatCount: "indefinite"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "opacity",
                        dur: "2s",
                        values: "1; 1; 0; 0;",
                        keyTimes: "0; 0.75; 0.9; 1",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("rect", {
                width: "5%",
                fill: "#ED4B9E",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "height",
                        dur: "2s",
                        values: "0%; 0%; 35%; 35%; 10%; 10%",
                        keyTimes: "0; 0.25; 0.375; 0.5; 0.625; 1",
                        repeatCount: "indefinite"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "y",
                        dur: "2s",
                        values: "25%; 25%; 10%; 10%; 25%; 25%",
                        keyTimes: "0; 0.25; 0.375; 0.5; 0.625; 1",
                        repeatCount: "indefinite"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "rx",
                        dur: "2s",
                        values: "0%; 0%; 100%; 100%;",
                        keyTimes: "0; 0.6; 0.625; 1",
                        repeatCount: "indefinite"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "x",
                        dur: "2s",
                        values: "52.5%; 52.5%; 47.5%; 47.5%;",
                        keyTimes: "0; 0.7; 0.8; 1",
                        repeatCount: "indefinite"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "opacity",
                        dur: "2s",
                        values: "1; 1; 0; 0;",
                        keyTimes: "0; 0.75; 0.9; 1",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("rect", {
                width: "5%",
                fill: "#31D0AA",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "height",
                        dur: "2s",
                        values: "0%; 0%; 35%; 35%; 10%; 10%",
                        keyTimes: "0; 0.375; 0.5; 0.5; 0.625; 1",
                        repeatCount: "indefinite"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "y",
                        dur: "2s",
                        values: "15%; 15%; 0%; 0%; 25%; 25%",
                        keyTimes: "0; 0.375; 0.5; 0.5; 0.625; 1",
                        repeatCount: "indefinite"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "rx",
                        dur: "2s",
                        values: "0%; 0%; 100%; 100%;",
                        keyTimes: "0; 0.6; 0.625; 1",
                        repeatCount: "indefinite"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "x",
                        dur: "2s",
                        values: "62.5%; 62.5%; 47.5%; 47.5%;",
                        keyTimes: "0; 0.7; 0.8; 1",
                        repeatCount: "indefinite"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "opacity",
                        dur: "2s",
                        values: "1; 1; 0; 0;",
                        keyTimes: "0; 0.75; 0.9; 1",
                        repeatCount: "indefinite"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var ChartLoaders_CandleChartLoaderSVG = (CandleChartLoaderSVG);

;// CONCATENATED MODULE: ./src/views/Info/components/ChartLoaders/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  margin-left: auto;\n  margin-right: auto;\n  top: 50%;\n  left: 0;\n  right: 0;\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var LoadingText = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-42fcc4ac-0"
})(_templateObject());
var LoadingIndicator = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-42fcc4ac-1"
})(_templateObject1());
var BarChartLoader = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoadingIndicator, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartLoaders_BarChartLoaderSVG, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingText, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "textSubtle",
                    fontSize: "20px",
                    children: t("Loading chart data...")
                })
            })
        ]
    });
};
var LineChartLoader = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoadingIndicator, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartLoaders_LineChartLoaderSVG, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingText, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "textSubtle",
                    fontSize: "20px",
                    children: t("Loading chart data...")
                })
            })
        ]
    });
};
var CandleChartLoader = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoadingIndicator, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartLoaders_CandleChartLoaderSVG, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingText, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "textSubtle",
                    fontSize: "20px",
                    children: t("Loading chart data...")
                })
            })
        ]
    });
};


/***/ })

}]);